import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../context/LangContext";
import { BOOK_PATH, INSTAGRAM_URL, STRINGS } from "../../data/content";
import Logo from "./Logo";

function InstagramIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="2" width="20" height="20" rx="5" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" stroke="none" />
    </svg>
  );
}

export default function Navbar() {
  const { lang, toggle, t } = useLang();
  return (
    <nav>
      <div className="nav-inner">
        <Link to="/" style={{ textDecoration: "none" }} aria-label="Blanktjern Coaching">
          <Logo variant="dark" size="md" />
        </Link>
        <div className="nav-right">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-instagram"
            aria-label="Instagram"
          >
            <InstagramIcon />
          </a>
          <button className="btn-lang" onClick={toggle} aria-label="Toggle language">
            {lang === "no" ? "EN" : "NO"}
          </button>
          <Link to={BOOK_PATH} className="btn">
            {t(STRINGS.bookCallShort)}
          </Link>
        </div>
      </div>
    </nav>
  );
}
